import React from 'react';
import {map, difference, union, orderBy} from 'lodash';
import {Badge} from 'react-bootstrap';


class Schools extends React.Component {
    constructor(props) {
        super(props);
        this.state = { schools: [], showMore: false };
        this.toggleShowMore = this.toggleShowMore.bind(this);
    }

    componentDidMount() {
        var self = this;
        if (self.props.polygon) {
            this.getSchools(self.props.polygon)
        }
        else {
            var url = "";
            var highSchoolDistrict = self.props.highSchoolDistrict;
            if (highSchoolDistrict) {
                var arry = highSchoolDistrict.split('-');
                if (arry !== null && arry.length > 0 && arry[0].trim() !== "") {
                    var districtId = arry[0].trim();

                    url = window.sessionStorage.getItem("RootAPI") + "listings/" + self.props.propertyId + "/schools/" + districtId;
                }
                else {
                    url = window.sessionStorage.getItem("RootAPI") + "listings/" + self.props.propertyId + "/schools";
                }
            }
            else {
                url = window.sessionStorage.getItem("RootAPI") + "listings/" + self.props.propertyId + "/schools";
            }
            fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
                },
                method: "GET"
            })
            .then(response => { return response.ok ? response.json() : {}; })
            .then(json => {
                if (json) {
                    if (json.length > 0 && !json[0].ErrorMessage && !json[0].ErrorCode) {
                        var sLst = json.map(s => {
                            s.header = s.SchoolType + " " + s.SchoolCategory;
                            return s;
                        });
                        self.setState({ schools: sLst });
                    }
                }
            })
            .catch(function (data) {
                console.log(data)
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.polygon !== nextProps.polygon) {
            this.getSchools(nextProps.polygon);
        }
    }

    getSchools = (polygon) => {
        var self = this;
        var requestBody = {
            polygon: polygon 
           // latlong:  '-98.2656 29.5637' // for property detail
        }
        var url = window.sessionStorage.getItem("RootAPI") + "neighborhood/schools";

        fetch(url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
            },
            method: "POST",
            body: JSON.stringify(requestBody)
        })
        .then(response => {
            if (response.ok) return response.json()
            else throw Error(response.statusText)
        })
        .then(json => {
            var sLst = json.map(s => {
                s.header = s.SchoolType + " " + s.SchoolCategory;
                return s;
            });
            self.setState({ schools: sLst });
        })
        .catch(function (data) {
            console.log(data);
        });
    }

    toggleShowMore(){
        this.setState({showMore: !this.state.showMore});
    }

    renderSchoolsWithSimpleDesign(results) {
        let idx = 0;
        const sortedList = orderBy(results, ((a) => a.SchoolRating), ['desc']);
        
        var topList = [];
        topList = union(topList, sortedList.filter(a => a.SchoolType.toLowerCase() === "public" && 
            a.SchoolCategory.toLowerCase().indexOf("elementary") !== -1).slice(0,1));
        topList = union(topList, sortedList.filter(a => a.SchoolType.toLowerCase() === "public" && 
            a.SchoolCategory.toLowerCase().indexOf("middle") !== -1).slice(0,1));
        topList = union(topList, sortedList.filter(a => a.SchoolType.toLowerCase() === "public" && 
            a.SchoolCategory.toLowerCase().indexOf("high") !== -1).slice(0,1));
        if(topList.length < 3){
            topList = union(topList, difference(sortedList, topList).slice(0, (3 - topList.length)));
        }
        if(this.state.showMore){
            topList = union(topList, difference(sortedList, topList));
        }        
        
        const items = map(topList, school => {                
                var distance = (school && school.Distance) ? school.Distance.toFixed(2) : 0;
                const item = (
                    <SchoolSectionDetail key={idx}
                        rating={school.SchoolRating}
                        schoolName={school.SchoolName}
                        grades={school.SchoolGradelevel}
                        distance={distance + " miles"} />
                );
                idx++;
                return [
                    !!idx,
                    null,
                    item];
            });

        return (
            <div>
                <table className="area_data school_data" cellPadding="0" cellSpacing="0">
                    <thead>
                        <SchoolSectionTitle
                            rating='Rating'
                            schoolName='School name'
                            grades='Grades'
                            distance='Distance' />
                    </thead>
                    <tbody>{items}</tbody>
                </table>
                {results && results.length > 3 &&
                    <div className='btn-showmore-schools' onClick={this.toggleShowMore}>
                    {this.state.showMore ? 'See less' : 'See more'} <i className={this.state.showMore ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></i>
                </div>
                }
            </div>
        );
    }

    render() {

        if(!this.state.schools || this.state.schools.length === 0){
            return <div />;
        }

        return (
            <div className="row tour-nearby-school">
                <div className="col-sm-12">
                    <h3 style={{marginTop: "5px"}}>{(this.props.highSchoolDistrict && this.props.highSchoolDistrict !== "") ? "School District: " + this.props.highSchoolDistrict : "Nearby Schools"}</h3>
                    <div>
                        {this.renderSchoolsWithSimpleDesign(this.state.schools)}
                    </div>
                </div>
            </div>
        );
    }
}

class SchoolSectionDetail extends React.Component {
    render(props) {
        var rating = parseInt(this.props.rating,10);
        var ratColor = {backgroundColor: "#5cb85c"};
        if(rating > 6){
            ratColor = {backgroundColor: "#5cb85c"};
        }
        else if(rating > 3){
            ratColor = {backgroundColor: "#337ab7"};
        }
        else if(rating === 0){
            ratColor = {};
        }
        else{
            ratColor = {backgroundColor: "#f0ad4e"};
        }
        return (
            <tr>
                <td data-title=""><Badge className="roundbadge" style={ratColor}>{(rating === 0) ? "NR" : rating}</Badge></td>
                <td data-title="&nbsp;">{this.props.schoolName}</td>
                <td data-title="Grades">{this.props.grades}</td>
                <td data-title="Distance">{this.props.distance}</td>
            </tr>
        );
    }
}
class SchoolSectionTitle extends React.Component {
    render(props) {
        return (
            <tr>
                <th>{this.props.rating}</th>
                <th>{this.props.schoolName}</th>
                <th>{this.props.grades}</th>
                <th>{this.props.distance}</th>
            </tr>
        );
    }
}

export default Schools;